import React from 'react'
import ExperienceSection from '../components/ExperienceSection'
import ProjectsSection from '../components/ProjectsSection'
import About from '../components/Sidebar/About'
import Links from '../components/Sidebar/Links'

import './style.scss'

const IndexPage = () => (
    <div className="index">
      <div className="main">
        <h5>
          Hi, I'm <span className="bold">Martin Roldan</span>
        </h5>

        <h3 className="bold">
          Software developer with over 8 years' experience building 
          rich web applications for clients in USA and Mexico in diverse
          industry sectors.
        </h3>

        <ExperienceSection />
        
      </div>

      <div className="aside">
        <div className="top">
          <About />
        </div>
        <div className="bottom">
          <Links />
        </div>
      </div>
    </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js